import React, { createContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useAuth } from "@frontegg/react";

const SocketContext = createContext(null);

const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.accessToken) {
      setSocket(null);
      return;
    }

    const serverUrl = import.meta.env.VITE_DASHBOARD_API_URL;
    const options = { auth: { token: user.accessToken }, transports: ["websocket"] };

    const newSocket = io(serverUrl, options);
    setSocket(newSocket);

    newSocket.on("disconnect", () => {
      newSocket.auth = { token: user.accessToken };
      newSocket.connect();
    });

    return () => {
      newSocket.disconnect();
      setSocket(null);
    };
  }, [user]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export { SocketProvider, SocketContext };
